import React, { Fragment, useEffect, useState } from "react";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import { forgetPassword, sendOtp } from "../../../../services/authService";
import { toast } from "react-toastify";
import OtpInput from "../../../form/OtpInput";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "../../../form/Form";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "../../../../util/apiUtils";

const ResetPasswordForm = ({ email }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const validation = {
    confirmPassword: {
      required: true,
      message: "Confirm Password is Required",
    },
    newPassword: [
      {
        type: "newPassword",
        minLength: 8,
        required: true,
        message:
          "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
      },
    ],
    ...(!(
      location?.state?.hasOwnProperty("hasPassword") &&
      location?.state?.hasPassword === false
    ) && {
      otp: { required: true, message: "Please Enter Valid Otp" },
    }),
  };

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (!location?.state?.email && !email) {
      toast.error("Email is missing. Please try again.");
      navigate("/login");
      return;
    }
  }, [location?.state]);

  const resendOtp = async () => {
    if (!location?.state?.email && !email) {
      toast.error("Email is missing. Please try again.");
      return;
    }

    try {
      const response = await sendOtp({
        email: location?.state ? location?.state?.email : email,
      });

      if (response?.status === 200 || response?.status === 201) {
        setFieldsValue({ otp: "" });
        toast.success("OTP resent successfully!");
      } else {
        toast.warning(response?.message || "Failed to resend OTP.");
      }
    } catch (error) {
      toast.error("An error occurred while resending OTP.");
    }
  };

  const {
    mutate: resetPassword,
    isPending,
    error,
  } = useMutation({
    mutationFn: async (value) => {
      const res = await apiRequest("post", "reset-password", {
        body: {
          ...value,
          email: location?.state?.email,
          type: "newPasswordSetup",
        },
      });
      return res?.data;
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        navigate("/login");
      }
    },
  });

  return (
    <Form
      className="space-y-4"
      onSubmit={resetPassword}
      handleSubmit={handleSubmit}
    >
      <Fragment>
        <div className="mt-2 relative">
          {!(
            location?.state?.hasOwnProperty("hasPassword") &&
            location?.state?.hasPassword === false
          ) && (
            <OtpInput
              label={"Enter the secure code from your email"}
              handleOtpChange={(val) =>
                handleChange({
                  target: { value: val, name: "otp" },
                })
              }
              inputName="otp"
              labelChildClass={
                "!h-12 !rounded-lg !border-white !bg-transparent !text-white placeholder:!text-white focus:!border-primary"
              }
              {...formValidate(errors, "otp")}
            />
          )}
        </div>

        <div className="mt-2">
          <Input
            label={"New Password"}
            inputPlaceholder={"Enter Your Password"}
            labelClasses={"!text-xs"}
            inputType={"password"}
            value={values.password}
            inputName={"newPassword"}
            onChange={handleChange}
            {...formValidate(errors, "newPassword")}
          />
        </div>

        <div className="mt-2">
          <Input
            label={"Confirm Password"}
            inputPlaceholder={"Enter Confirm Password"}
            labelClasses={"!text-xs"}
            inputType={"password"}
            value={values.confirmPassword}
            inputName={"confirmPassword"}
            onChange={handleChange}
            {...formValidate(errors, "confirmPassword")}
          />
        </div>
      </Fragment>
      <div className="relative">
        <Button
          buttonLabel={"Reset Password"}
          buttonType="submit"
          buttonLabelClasses={"!text-lg !font-semibold"}
          buttonClasses={"!w-full !h-12 !rounded-lg"}
          {...(isPending && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </Form>
  );
};

export default ResetPasswordForm;
